import { Panel, Row, ScreenBody, ScreenHeader, Stat, StatGrid } from '@/components/ui/primitives';
import { useSession } from '@/store/session';
import type { Screen } from './Shell';
import { Icon, type IconName } from '@/components/ui/Icon';

/**
 * The hub for everything not on the bottom nav. Six tabs is the mobile ceiling,
 * so the seven meta screens live behind one list rather than a scrolling tab bar.
 */
const ROWS: { icon: IconName; title: string; subtitle: string; to: Screen }[] = [
  { icon: 'map', title: 'Maps', subtitle: 'Every cave, and how to reach it', to: 'maps' },
  { icon: 'ad', title: 'Reward Hub', subtitle: 'Watch ads and earn Shwe Kyat', to: 'rewardhub' },
  { icon: 'kyat', title: 'Withdraw', subtitle: 'Cash out your Shwe Kyat', to: 'withdraw' },
  { icon: 'target', title: 'Missions', subtitle: 'Daily and weekly goals', to: 'missions' },
  { icon: 'trophy', title: 'Achievements', subtitle: 'Long-run milestones', to: 'achievements' },
  { icon: 'leaderboard', title: 'Leaderboard', subtitle: 'How you rank this week', to: 'leaderboard' },
  { icon: 'hero', title: 'Profile', subtitle: 'Your mining log', to: 'profile' },
  { icon: 'settings', title: 'Settings', subtitle: 'Account and about', to: 'settings' },
];

export function Functions({ onBack, onGo }: { onBack: () => void; onGo: (s: Screen) => void }) {
  const wallet = useSession((s) => s.wallet);
  const flags = useSession((s) => s.flags);

  return (
    <ScreenBody>
      <ScreenHeader icon={<Icon name="settings" size={22} />} title="Functions" onBack={onBack} />

      <Panel>
        <StatGrid>
          <Stat k="Shwe Coins" v={wallet.coins.toLocaleString('en-US')} tone="coin" />
          <Stat k="Shwe Kyat" v={wallet.kyat} tone="kyat" />
        </StatGrid>
      </Panel>

      <Panel className="mt-3">
        {ROWS.map((r) => (
          <Row
            key={r.to}
            icon={<Icon name={r.icon} size={22} />}
            title={r.title}
            subtitle={
              r.to === 'withdraw' && !flags.withdraw_enabled
                ? 'Link an account and verify your phone first'
                : r.subtitle
            }
            onClick={() => onGo(r.to)}
            right={<Icon name="chevron-right" size={16}
                          className="shrink-0 text-ink-dim" />}
          />
        ))}
      </Panel>
    </ScreenBody>
  );
}
